import React from "react";
// Common Components
import {
  DynamicDropdown,
  Button,
  TextInput,
  DynamicMultiSelectDropdown,
  StaticDropdown,
} from "src/Components";
// Request
import {
  getBaseInstruments,
  getOptionInstruments,
} from "src/Requests/coveredCall";
// Types
import { IRollSearchParam } from "src/Interfaces/coveredCall";
import { ExchangeType } from "src/Interfaces/connections";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: IRollSearchParam;
  onSubmit: () => void;
}

const exchangeTypeOption: DropdownItem[] = [
  { id: ExchangeType.StockExchange, name: "اوراق بهادار" },
  { id: ExchangeType.CommodityExchange, name: "کالا" },
];

const PairPositionSearchParamUI: React.FC<IProps> = ({
  searchParam,
  searchParamChangeHandler,
  onSubmit,
}) => {
  return (
    <div className="border border-gray-300 rounded p-3 flex flex-col gap-3 !w-[350px] !min-w-[350px]">
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <DynamicMultiSelectDropdown
            dropdown={{
              name: "baseInstrumentIds",
              placeholder: "نماد پایه",
              extraLabel: true,
            }}
            getData={getBaseInstruments}
            onChange={searchParamChangeHandler}
            value={searchParam?.baseInstrumentIds}
          />
        </div>
        <div className="w-full">
          <StaticDropdown
            dropdown={{
              name: "exchangeType",
              placeholder: "بورس",
              extraLabel: true,
            }}
            onChange={searchParamChangeHandler}
            options={exchangeTypeOption}
            value={searchParam?.exchangeType?.toString() || ""}
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "sourceInstrumentId",
              placeholder: "مبدا رول",
              extraLabel: true,
            }}
            getData={getOptionInstruments}
            onChange={searchParamChangeHandler}
            value={searchParam?.sourceInstrumentId}
          />
        </div>
        <div className="w-full">
          <DynamicDropdown
            dropdown={{
              name: "destInstrumentId",
              placeholder: "مقصد رول",
              extraLabel: true,
            }}
            getData={getOptionInstruments}
            onChange={searchParamChangeHandler}
            value={searchParam?.destInstrumentId}
          />
        </div>
      </div>

      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-1/2">
          <TextInput
            name="minProfitPercentage"
            label="حداقل % بازده روزانه رول"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minProfitPercentage?.toString() || ""}
            kind="negativeDecimalNumbers"
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minYesterdayVolume"
            label="حداقل حجم معاملات روز قبل مقصد"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minYesterdayVolume?.toString() || ""}
            kind="number"
          />
        </div>
        <div className="w-full">
          <TextInput
            name="minYesterdayValue"
            label="حداقل ارزش معاملات روز قبل مقصد"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minYesterdayValue?.toString() || ""}
            kind="number"
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minSourceDTM"
            label="حداقل DTM مبدا"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minSourceDTM?.toString() || ""}
            kind="number"
          />
        </div>
        <div className="w-full">
          <TextInput
            name="maxSourceDTM"
            label="حداکثر DTM مبدا"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.maxSourceDTM?.toString() || ""}
            kind="number"
          />
        </div>
      </div>
      <div className="flex flex-row justify-start items-start gap-3 w-full">
        <div className="w-full">
          <TextInput
            name="minDestinationDTM"
            label="حداقل DTM مقصد"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.minDestinationDTM?.toString() || ""}
            kind="number"
          />
        </div>
        <div className="w-full">
          <TextInput
            name="maxDestinationDTM"
            label="حداکثر DTM مقصد"
            extraLabel
            onChange={searchParamChangeHandler}
            value={searchParam?.maxDestinationDTM?.toString() || ""}
            kind="number"
          />
        </div>
      </div>
      <Button onClick={onSubmit} text="جستجو" variant="contained" />
    </div>
  );
};

export default PairPositionSearchParamUI;
